import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_CUSTOMER,
  DELETE_CUSTOMER,
  EXPORT_CUSTOMER,
  GET_CUSTOMER,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_SELECT_LISTING,
  UPDATE_CUSTOMER,
  ADD_CUSTOMER_POINTS,
  ADD_CUSTOMER_VOUCHERS,
} from "./actionTypes";

import {
  addCustomerFail,
  addCustomerSuccess,
  deleteCustomerFail,
  deleteCustomerSuccess,
  exportCustomerFail,
  exportCustomerSuccess,
  getCustomerDetailsFail,
  getCustomerDetailsSuccess,
  getCustomerFail,
  getCustomerSelectListingFail,
  getCustomerSelectListingSuccess,
  getCustomerSuccess,
  updateCustomerFail,
  updateCustomerSuccess,
  addCustomerPointsFail,
  addCustomerPointsSuccess,
  addCustomerVoucherFail,
  addCustomerVoucherSuccess,
} from "./actions";

import {
  addNewCustomer,
  customerDetailsApi,
  customerListingApi,
  customerSelectListingApi,
  delCustomer,
  exportCustomerApi,
  updateCustomer,
  addCustomerPoints,
  addCustomerVouchers,
} from "./customerApi.js";

function* fetchCustomer({ payload: length, page, keyword, status, sort, sort_by }) {
  try {
    const response = yield call(customerListingApi, length, page, keyword, status, sort, sort_by)
    yield put(getCustomerSuccess(response))
  } catch (error) {
    yield put(getCustomerFail(error))
  }
}
function* fetchCustomerDetails({ payload: id, point_sort, point_order, voucher_sort, voucher_order }) {
  try {
    const response = yield call(customerDetailsApi, id, point_sort, point_order, voucher_sort, voucher_order)
    yield put(getCustomerDetailsSuccess(response))
  } catch (error) {
    yield put(getCustomerDetailsFail(error))
  }
}

function* fetchCustomerSelectListing() {
  try {
    const response = yield call(customerSelectListingApi)

    yield put(getCustomerSelectListingSuccess(response))
  } catch (error) {
    yield put(getCustomerSelectListingFail(error))
  }
}

function* onAddNewCustomer({ payload: customer }) {
  try {
    const response = yield call(addNewCustomer, customer)
    yield put(addCustomerSuccess(response))
  } catch (error) {
    yield put(addCustomerFail(error))
  }
}

function* onUpdateCustomer({ payload: id, customer }) {
  try {
    const response = yield call(updateCustomer, id, customer)
    yield put(updateCustomerSuccess(response))
  } catch (error) {
    yield put(updateCustomerFail(error))
  }
}

function* onDelCustomer({ payload: id }) {
  try {
    const response = yield call(delCustomer, id)
    yield put(deleteCustomerSuccess(response))
  } catch (error) {
    yield put(deleteCustomerFail(error))
  }
}

function* onExportCustomer({payload: payload}) {
  try {
    const response = yield call(exportCustomerApi, payload)
    yield put(exportCustomerSuccess(response))
  } catch (error) {
    yield put(exportCustomerFail(error))
  }
}

function* onaddCustomerPoints({ payload: id, customer }) {
  try {
    const response = yield call(addCustomerPoints, id, customer)
    yield put(addCustomerPointsSuccess(response))
  } catch (error) {
    yield put(addCustomerPointsFail(error))
  }
}

function* onaddCustomerVouchers({ payload: id, customer }) {
  try {
    const response = yield call(addCustomerVouchers, id, customer)
    yield put(addCustomerVoucherSuccess(response))
  } catch (error) {
    yield put(addCustomerVoucherFail(error))
  }
}



function* CustomerSaga() {
  yield takeEvery(GET_CUSTOMER, fetchCustomer)
  yield takeEvery(GET_CUSTOMER_SELECT_LISTING, fetchCustomerSelectListing)
  yield takeEvery(GET_CUSTOMER_DETAILS, fetchCustomerDetails)
  yield takeEvery(ADD_NEW_CUSTOMER, onAddNewCustomer)
  yield takeEvery(UPDATE_CUSTOMER, onUpdateCustomer)
  yield takeEvery(DELETE_CUSTOMER, onDelCustomer)
  yield takeEvery(EXPORT_CUSTOMER, onExportCustomer)
  yield takeEvery(ADD_CUSTOMER_POINTS, onaddCustomerPoints)
  yield takeEvery(ADD_CUSTOMER_VOUCHERS, onaddCustomerVouchers)

}

export default CustomerSaga
